import web from "../web";

class NotesService {
    index(token){
        return web.get("/api/notes", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/notes", data, { headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new NotesService()